module.exports = __webpack_public_path__ + "img/public_resources_play_black.2d8a5ce0.svg";